import {create} from 'zustand';
import {createAIAnalysisSlice} from './aiAnalysisSlice';
import {createEditorSessionSlice} from './editorSessionSlice';
import {createLeftPanelSearchSlice} from './leftPanelSearchSlice';
import {createReportRecordSlice} from './reportRecordSlice';

/**
 * Combined store for the report editor pages (reportEditorPage/ and the legacy
 * reportPage/). Composed from focused slices — see each slice file for what it owns.
 * The combined shape is the public interface every `useReportStore(selector)` call
 * relies on; keep slice field names disjoint so this spread stays a flat merge.
 */
export const useReportStore = create((set, get) => ({
    ...createEditorSessionSlice(set, get),
    ...createLeftPanelSearchSlice(set, get),
    ...createReportRecordSlice(set, get),
    ...createAIAnalysisSlice(set, get),
}));
